import { Component, Input, Output, EventEmitter, SimpleChanges, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators, ValidatorFn } from '@angular/forms';
import { ScheduleType, Schedule, ScheduleDayOfWeek, ScheduleMonth, ScheduleOrdinal } from 'DiscoveryEngine.TS/Utils';
import { ComponentBase } from '../../../common/ComponentBase';

@Component({
	selector: 'schedule',
	templateUrl: './schedule.component.html',
	styleUrls: ['./schedule.component.scss']
})
export class ScheduleComponent extends ComponentBase implements OnInit, OnChanges, OnDestroy {

	@Input()
	public target: Schedule;

	public SettingsForm: UntypedFormGroup;

	public ScheduleType: UntypedFormControl;
	public Minutes_Interval: UntypedFormControl;
	public Hours_Interval: UntypedFormControl;
	public Hours_AfterHour: UntypedFormControl;
	public Days_Interval: UntypedFormControl;
	public Days_Time: UntypedFormControl;
	public Weekly_DaysOfWeek: UntypedFormControl;
	public Weekly_Time: UntypedFormControl;
	public Monthly_DayOfMonth: UntypedFormControl;
	public Monthly_Time1: UntypedFormControl;
	public Monthly_DayOrdinal: UntypedFormControl;
	public Monthly_DayOfWeek: UntypedFormControl;
	public Monthly_Time2: UntypedFormControl;

	// Attributes needed to work around <p-calendar>'s inability
	// to work correctly with model-based forms
	public Days_Time_Value: Date;

	public DaysOfWeek_Values = [
		{ label: "Sun", value: "0" },
		{ label: "Mon", value: "1" },
		{ label: "Tue", value: "2" },
		{ label: "Wed", value: "3" },
		{ label: "Thu", value: "4" },
		{ label: "Fri", value: "5" },
		{ label: "Sat", value: "6" },
	];

	constructor(private fb: UntypedFormBuilder) {
		super();
		this.target = null;
	}

	public ngOnInit(): void {
		this.BuildForm();
	}

	public ngOnChanges(changes: SimpleChanges): void {

		//if (this.destroyed)
		//	return;

		//if (changes["agent"]) {
		//	this.setViewProperties();
		//}

		this.BuildForm();
	}

	public ngOnDestroy(): void {
		//this.destroyed = true;

	}

	private get DefaultTime(): Date {
		let now = new Date();
		return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
	}

	public SchedTypeEquals(value: string): boolean {
		if (this.ScheduleType) {
			return (this.ScheduleType.value === value);
		}
		else {
			return false;
		}
	}

	public BuildForm(): void {
		let scheduleType = "4";	// Days_Interval
		let minutes_Interval = 1;
		let hours_Interval = 1;
		let hours_AfterHour = 0;
		let days_Interval = 1;
		let days_Time = this.DefaultTime;
		let weekly_DaysOfWeek: string[] = ["1", "2", "3", "4", "5"]; // [Mon, Tue, Wed, Thu, Fri]
		let weekly_Time = this.DefaultTime;
		let monthly_DayOfMonth = 1;
		let monthly_Time1 = this.DefaultTime;
		let monthly_DayOrdinal = "0";	// First
		let monthly_DayOfWeek = "1";	// Monday
		let monthly_Time2 = this.DefaultTime;

		if (this.target) {
			let value = this.target;

			scheduleType = value.Type + "";

			switch (value.Type) {
				case ScheduleType.Minutes_Interval:
					minutes_Interval = value.OneInterval;
					break;
				case ScheduleType.Hours_Interval:
					hours_Interval = value.OneInterval;
					hours_AfterHour = value.OneStartTime.getMinutes();
					break;
				case ScheduleType.Days_Interval:
					days_Interval = value.OneInterval;
					days_Time = value.OneStartTime;
					break;
				case ScheduleType.Weekly_SelectedDays:
					weekly_DaysOfWeek = [];
					value.DaysOfWeek.ForEach((dow: ScheduleDayOfWeek) => {
						weekly_DaysOfWeek.push(dow + "");
					});
					weekly_Time = value.OneStartTime;
					break;
				case ScheduleType.Monthly_NthDay:
					monthly_DayOfMonth = value.OneDayOfMonth;
					monthly_Time1 = value.OneStartTime;
					break;
				case ScheduleType.Monthly_OrdinalDay:
					monthly_DayOrdinal = value.OneOrdinal + "";
					monthly_DayOfWeek = value.OneDayOfWeek + "";
					monthly_Time2 = value.OneStartTime;
					break;
				default:
					console.assert(false);
					break;
			}
		}

		this.ScheduleType = new UntypedFormControl(scheduleType, Validators.required);
		this.Minutes_Interval = new UntypedFormControl({ value: minutes_Interval, disabled: scheduleType != "2" });
		this.Hours_Interval = new UntypedFormControl({ value: hours_Interval, disabled: scheduleType != "3" });
		this.Hours_AfterHour = new UntypedFormControl({ value: hours_AfterHour, disabled: scheduleType != "3" });
		this.Days_Interval = new UntypedFormControl({ value: days_Interval, disabled: scheduleType != "4" });
		this.Days_Time = new UntypedFormControl({ value: days_Time, disabled: scheduleType != "4" });
		this.Days_Time_Value = days_Time;	// Hack
		this.Weekly_DaysOfWeek = new UntypedFormControl({ value: weekly_DaysOfWeek, disabled: scheduleType != "5" });
		this.Weekly_Time = new UntypedFormControl({ value: weekly_Time, disabled: scheduleType != "5" });
		this.Monthly_DayOfMonth = new UntypedFormControl({ value: monthly_DayOfMonth, disabled: scheduleType != "6" });
		this.Monthly_Time1 = new UntypedFormControl({ value: monthly_Time1, disabled: scheduleType != "6" });
		this.Monthly_DayOrdinal = new UntypedFormControl({ value: monthly_DayOrdinal, disabled: scheduleType != "7" });
		this.Monthly_DayOfWeek = new UntypedFormControl({ value: monthly_DayOfWeek, disabled: scheduleType != "7" });
		this.Monthly_Time2 = new UntypedFormControl({ value: monthly_Time2, disabled: scheduleType != "7" });

		this.enableDisableControls();

		this.SettingsForm = this.fb.group({
			ScheduleType: this.ScheduleType,
			Minutes_Interval: this.Minutes_Interval,
			Hours_Interval: this.Hours_Interval,
			Hours_AfterHour: this.Hours_AfterHour,
			Days_Interval: this.Days_Interval,
			Days_Time: this.Days_Time,
			Weekly_DaysOfWeek: this.Weekly_DaysOfWeek,
			Weekly_Time: this.Weekly_Time,
			Monthly_DayOfMonth: this.Monthly_DayOfMonth,
			Monthly_Time1: this.Monthly_Time1,
			Monthly_DayOrdinal: this.Monthly_DayOrdinal,
			Monthly_DayOfWeek: this.Monthly_DayOfWeek,
			Monthly_Time2: this.Monthly_Time2,
		},
			{
				// These validators are implemented at the form level because
				// the FormControl.valid property always returns false for
				// disabled controls, and for controls that are initially disabled
				// it never updates.  All of this made doing validation at the
				// control level very difficult if not impossible.
				validator: Validators.compose([
					this.text_field_valid(this.Minutes_Interval, "minutes_interval", 1, 999),
					this.text_field_valid(this.Hours_Interval, "hours_interval", 1, 999),
					this.text_field_valid(this.Hours_AfterHour, "hours_after_hour", 0, 59),
					this.text_field_valid(this.Days_Interval, "days_interval", 1, 999),
					this.time_field_value(this.Days_Time, "days_time"),
					this.multiselect_field_valid(this.Weekly_DaysOfWeek, "weekly_days_of_week"),
					this.time_field_value(this.Weekly_Time, "weekly_time"),
					this.time_field_value(this.Monthly_Time1, "monthly_time_1"),
					this.time_field_value(this.Monthly_Time2, "monthly_time_2"),
				])
			});
	}

	public enableDisableControls(): void {
		this.enableDisableFormControl(this.Minutes_Interval, this.SchedTypeEquals('2'));
		this.enableDisableFormControl(this.Hours_Interval, this.SchedTypeEquals('3'));
		this.enableDisableFormControl(this.Hours_AfterHour, this.SchedTypeEquals('3'));
		this.enableDisableFormControl(this.Days_Interval, this.SchedTypeEquals('4'));
		this.enableDisableFormControl(this.Monthly_DayOfMonth, this.SchedTypeEquals('6'));
		this.enableDisableFormControl(this.Monthly_DayOrdinal, this.SchedTypeEquals('7'));
		this.enableDisableFormControl(this.Monthly_DayOfWeek, this.SchedTypeEquals('7'));
	}

	private makeResult(errors: string[]): any {
		if (errors.length > 0) {
			let result = {};
			for (let i = 0; i < errors.length; ++i) {
				result[errors[i]] = { valid: false };
			}
			return result;
		}
		else {
			return null;
		}
	}

	private multiselect_field_valid(a: UntypedFormControl, fieldName: string): ValidatorFn {
		return () => {
			let errors: string[] = [];

			if (this.notEmpty()(a)) {
				errors.push(fieldName + "_notEmpty");
			}

			if (errors.length > 0) {
				errors.push(fieldName + "_valid");
			}

			return this.makeResult(errors);
		};
	}

	private time_field_value(a: UntypedFormControl, fieldName: string): ValidatorFn {
		return () => {
			let errors: string[] = [];

			if (this.notEmpty()(a)) {
				errors.push(fieldName + "_notEmpty");
			}

			if (errors.length > 0) {
				errors.push(fieldName + "_valid");
			}

			return this.makeResult(errors);
		};
	}

	private text_field_valid(a: UntypedFormControl, fieldName: string, min: number, max: number): ValidatorFn {
		return () => {
			let errors: string[] = [];

			if (this.notEmpty()(a)) {
				errors.push(fieldName + "_notEmpty");
			}

			if (errors.length == 0) {
				if (this.minValue(min)(a)) {
					errors.push(fieldName + "_minValue");
				}

				if (this.maxValue(max)(a)) {
					errors.push(fieldName + "_maxValue");
				}
			}

			if (errors.length > 0) {
				errors.push(fieldName + "_valid");
			}

			return this.makeResult(errors);
		};
	}

	private _value: Schedule = new Schedule();
	public get value(): Schedule {
		let newValue = new Schedule();
		this._getTempChanges(newValue);

		if (!this._value.Equals(newValue)) {
			this._value = newValue;
		}

		return this._value;
	}

	public applyTempChanges(): void {
		if (this.target) {
			this._getTempChanges(this.target);
			this.BuildForm();
		}
	}

	private _getTempChanges(value: Schedule): void {
		if (this.SettingsForm) {
			value.Type = parseInt(this.ScheduleType.value);
			switch (value.Type) {
				case ScheduleType.Minutes_Interval:
					value.OneInterval = parseInt(this.Minutes_Interval.value);
					break;
				case ScheduleType.Hours_Interval:
					{
						value.OneInterval = parseInt(this.Hours_Interval.value);
						let minutes = parseInt(this.Hours_AfterHour.value);
						let now = new Date();
						value.OneStartTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(),
							0, minutes, 0, 0);
					}
					break;
				case ScheduleType.Days_Interval:
					value.OneInterval = parseInt(this.Days_Interval.value);
					value.OneStartTime = this.Days_Time.value;
					break;
				case ScheduleType.Weekly_SelectedDays:
					value.DaysOfWeek.Clear();
					this.Weekly_DaysOfWeek.value.forEach((dow: string) => {
						value.DaysOfWeek.Add(parseInt(dow));
					});
					value.OneStartTime = this.Weekly_Time.value;
					break;
				case ScheduleType.Monthly_NthDay:
					value.OneDayOfMonth = parseInt(this.Monthly_DayOfMonth.value);
					value.OneStartTime = this.Monthly_Time1.value;
					break;
				case ScheduleType.Monthly_OrdinalDay:
					value.OneOrdinal = parseInt(this.Monthly_DayOrdinal.value);
					value.OneDayOfWeek = parseInt(this.Monthly_DayOfWeek.value);
					value.OneStartTime = this.Monthly_Time2.value;
					break;
				default:
					console.assert(false);
					break;
			}
		}
	}

}
